// 这个Wrapper的主要作用是，当浏览器发生resize事件（手机上主要是键盘弹起）时，将原有的显示的元素隐藏
// 目前主要用在Pedant上面，因为弹出键盘后不需要显示在页面上了
import React from 'react';
import { observer } from 'mobx-react';
import { observable, action } from 'mobx';

@observer
export default class ResizeHiddenWrapper extends React.Component {
  initClientHeight = document.documentElement.clientHeight;
  @observable currentClientHeight = this.initClientHeight;
  componentWillUnmount() {
    window.removeEventListener('resize', this.checkResize);
  }
  @action checkResize = () => {
    this.currentClientHeight = document.documentElement.clientHeight;
  };
  componentDidMount() {
    window.addEventListener('resize', this.checkResize, false);
  }
  render() {
    const { initClientHeight, currentClientHeight } = this;
    //如果resize之后的高度大于等于初始高度，认为是可以显示下的，就直接渲染原本组件
    if (initClientHeight <= currentClientHeight) {
      return this.props.children;
    }
    //为了保证原有的react周期(componentDidMount之类的）不被打断，所以不管是否满足条件，都要渲染children
    return <div style={{ display: 'none' }}>{this.props.children}</div>;
  }
}
